<template>
  <View v-if="names.length" align="center" class="stack" :title="names.join(', ')" :aria-label="label" role="img">
    <Avatar v-for="name in shown" :key="name" :user-name="name" show-single-letter size="small" class="avatar" />
    <Text v-if="overflow" variant="label-small" color="secondary" class="overflow">+{{ overflow }}</Text>
  </View>
</template>

<script setup lang="ts">
import pluralize from 'pluralize';
import { computed } from 'vue';

import { Avatar, Text, View } from '@tallo/design-system';

const props = defineProps<{ names: string[] }>();

// Three faces read at a glance; past that a count says how many more without stretching the row
const shownCount = 3;

const shown = computed(() => props.names.slice(0, shownCount));
const overflow = computed(() => Math.max(0, props.names.length - shownCount));
const label = computed(() => `${pluralize('collaborator', props.names.length, true)}: ${props.names.join(', ')}`);
</script>

<style scoped lang="scss">
.stack {
  flex-shrink: 0;
}

// Overlapped like a hand of cards, each face rimmed so the next one reads as separate
.avatar {
  margin-left: calc(-1 * var(--t-spacing-xs));
  box-shadow: 0 0 0 2px var(--t-color-white);

  &:first-child {
    margin-left: 0;
  }
}

.overflow {
  margin-left: var(--t-spacing-xs);
}
</style>
